import React from 'react';

import { Image } from 'components/Image';
import { CityContacts } from 'interfaces';

import DepartmentContactItem from './DepartmentContactItem';

interface Props {
  cityContacts: CityContacts[];
}

const DepartmentContactsDetailed: React.FC<Props> = ({ cityContacts }) => (
  <div className="contact-content-item-detailed">
    {cityContacts.map((cities) => (
      <div key={cities.title} className="city-contacts">
        <h4 className="country-title">{cities.country}</h4>
        <div className="gatsby-image-wrapper">
          <Image imagePath={cities.imageName} alt={cities.title} />
        </div>
        <div className="city-info">
          <p className="city-title">{cities.title}</p>
          <p className="city-address">{cities.address1}</p>
          {cities.address2 && <p className="city-address">{cities.address2}</p>}
          <div className="department-contacts">
            {cities.departmentContacts.map((department) => (
              <DepartmentContactItem key={department.phone} name={department.name} phone={department.phone} />
            ))}
          </div>
        </div>
      </div>
    ))}
  </div>
);

export default DepartmentContactsDetailed;
